import _mapKeys from 'lodash/mapKeys'
import {
    launcherGetProfiles,
    launcherSaveSettings,
    launcherProcessStatus,
} from '../launcherBackend/launcher-command'
import { SERVERS_UPDATE_ACTIVE, USERS_READ_FROM_FORAGE, USERS_LOGIN_USER } from '../constants'
import { constants } from '../features/Settings'

function getProcessStatuses(state) {
    try {
        const server = state.servers.active
        const users = state.users.list[server]
        _mapKeys(users, (value, name) => launcherProcessStatus(server, name))
    } catch (error) {
        console.info(`Encountered error while running getProcessStatuses: ${error.message}`)
    }
}

const LauncherCommandMiddleware = store => next => (action) => {
    switch (action.type) {
        case USERS_READ_FROM_FORAGE: {
            const result = next(action)
            getProcessStatuses(store.getState())
            return result
        }
        case USERS_LOGIN_USER: {
            const result = next(action)
            launcherProcessStatus(action.payload.server, action.payload.user.username)
            return result
        }
        case SERVERS_UPDATE_ACTIVE: {
            const result = next(action)
            launcherGetProfiles(action.payload)
            getProcessStatuses(store.getState())
            return result
        }
        case constants.BACKEND_SETTINGS_CHANGED: {
            const result = next(action)
            launcherSaveSettings(action.payload)
            return result
        }

        default:
            return next(action)
    }
}

export default LauncherCommandMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/LauncherCommandMiddleware.js